module.exports = __webpack_public_path__ + "static/media/verification-img.388ef2fb.png";